/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            var self = this;
            var paginationId = 'pagination-' + nb.getSeq();
            this.set('paginationId', paginationId);
            this.onChange('initPagination', function (inEvent, inOpts) {
                var total = inOpts.total;
                $("#" + paginationId).pagination({
                    currentPage: inOpts.index,
                    totalPage: inOpts.total,
                    callback: function (current) {
                        self.set('requirePage', current);
                    }
                });
                if (total <= 1) {
                    this.set('paginationVisible', 'hide');
                } else {
                    this.set('paginationVisible', '');
                }
            }, this);

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/pagination/Pagination.js
// module id = 57
// module chunks = 1 3 11 12 14 16 17 24 31 33